module.exports = __webpack_public_path__ + "media/our_mission/photo_3-93db2a05.webp";